// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ISetupStepProps } from ".";
import { useCallback } from "react";
import * as React from "react";

import { ButtonGroup } from "components/button/ButtonGroup";
import { EventPlace, trackEngagement } from "helpers/analytics";

import { DomainAddedAction } from "../DomainSetupModal";

import { DNSSetupDomainHeader } from "./components";
import { StyledButton } from "./styles";

export const DomainAdded: React.FC<ISetupStepProps<DomainAddedAction>> = ({
  domains,
  modalAction,
  onClose,
  showCreateEmailDomainSuccessToast,
}) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const domain = domains?.find((d: any) => d.id === modalAction.domainId);

  const handleClose = useCallback(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      trackEngagement("Domains: Finish adding button clicked", EventPlace.Settings);
      event.preventDefault();
      onClose();
      showCreateEmailDomainSuccessToast();
    },
    [onClose, showCreateEmailDomainSuccessToast]
  );

  return (
    <>
      <DNSSetupDomainHeader text="Domain name" domainName={domain?.name} />
      <DNSSetupDomainHeader text="Ownership verification" badge="Verified" />
      <DNSSetupDomainHeader text="HelpDesk connection" badge="Connected" />

      <ButtonGroup>
        <StyledButton size="large" kind="primary" onClick={handleClose}>
          Finish adding
        </StyledButton>
      </ButtonGroup>
    </>
  );
};
